import { ROUTES } from '@/config/routes';

import { SearchTarget } from './types';

/** Where a hit opens in the app. Keyed off `target.kind` — never off the category —
 *  so the backend can rename or split a category without breaking navigation. */
const ROUTE_BY_TARGET_KIND: Record<string, string> = {
  order: ROUTES.AUTHORIZED.ORDERS,
  mediaPlan: ROUTES.AUTHORIZED.MEDIA_PLANS,
  space: ROUTES.AUTHORIZED.ADVERTISING_SPACES,
  package: ROUTES.AUTHORIZED.ADVERTISING_PACKAGES,
  location: ROUTES.AUTHORIZED.COMPANY_LOCATION_FORM,
  client: ROUTES.AUTHORIZED.COMPANY_CLIENT_FORM,
  company: ROUTES.AUTHORIZED.COMPANY_FORM,
  user: `${ROUTES.AUTHORIZED.ADMIN_USERS}/edit`,
};

/** `undefined` for a kind this build cannot open — the row stays visible but inert
 *  rather than navigating somewhere wrong. */
export function getSearchTargetRoute(target: SearchTarget): string | undefined {
  const base = ROUTE_BY_TARGET_KIND[target.kind];
  return base ? `${base}/${target.id}` : undefined;
}
